
import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, list_type, class_type, option_type, anonRecord_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { FormState__getValidation, ProcedureId, ProcedureTemplateId, FormState__startLoading, FormState__setValidationResponse_5219762A, ToolId as ToolId_1, RequestedValue$1, FormState_get_empty, AssignToolWithoutNotificationDto, ProcedureId_$reflection, ToolId_$reflection, RequestedValue$1_$reflection, FormState_$reflection, AssignToolWithoutNotificationDto_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DTO_CreateProcedureDto_$reflection, DTO_CreateProcedureDto, DTO_GetSenderHooksRequest_$reflection, DTO_GetSenderHooksRequest, DTO_SenderHookDto_$reflection } from "../../Shared/Procedure.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { ToolDetailDto_$reflection } from "../../Shared/Tool.js";
import { sortBy, toArray, isEmpty, append, max, filter, tryPick, sumBy, choose, singleton, empty, exists, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { add, empty as empty_1, contains } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { safeHash, equals, createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { Cmd_assignCmd } from "../../Requests/Tool.js";
import { uploadImage } from "../../Requests/Files.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_2, append as append_1, singleton as singleton_1, collect, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { TextButton } from "../../Components/Button.js";
import { utcNow, date as date_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ToolInfo } from "../../Widgets/ToolInfoWidget.js";
import { GroupedSelect } from "../../Components/Select.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { TextArea } from "../../Components/TextArea.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { OpenProcedureModal } from "../../Widgets/Procedure/Form/View.js";
import { Dialog } from "../../Components/Dialog.js";
import { Skeleton } from "../../Components/Skeleton.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectReceiver", "SetComment", "SelectReturnDate", "AssignedToolResponse", "OnAssignTool", "ReceiversFetched", "SenderHooksFetched", "StartSenderProcedure", "ContinueSenderProcedure", "SenderProcedureCreated", "SenderProcedureCompleted", "CloseProcedureModal", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.AssignToolFromUserToUserDialog.Msg", [], Msg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", string_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", list_type(Receiver_$reflection())]], [["Item", ClientApiResponse$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))]], [["Item", DTO_SenderHookDto_$reflection()]], [["procedureId", class_type("System.Guid")], ["templateId", class_type("System.Guid")]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Tool, Dto, SelectedReturnDate, SelectedReceiver, FormState, SuccessCallback, OnClose, Receivers, ToolId, SenderHooks, ActiveProcedureId, ActiveProcedureTemplateId, CompletedSenderHookTemplateIds, SenderImageFiles, ImageUploading) {
        super();
        this.Tool = Tool;
        this.Dto = Dto;
        this.SelectedReturnDate = SelectedReturnDate;
        this.SelectedReceiver = SelectedReceiver;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Receivers = Receivers;
        this.ToolId = ToolId;
        this.SenderHooks = SenderHooks;
        this.ActiveProcedureId = ActiveProcedureId;
        this.ActiveProcedureTemplateId = ActiveProcedureTemplateId;
        this.CompletedSenderHookTemplateIds = CompletedSenderHookTemplateIds;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Tools.AssignToolFromUserToUserDialog.State", [], State, () => [["Tool", ToolDetailDto_$reflection()], ["Dto", AssignToolWithoutNotificationDto_$reflection()], ["SelectedReturnDate", option_type(class_type("System.DateTime"))], ["SelectedReceiver", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["ToolId", ToolId_$reflection()], ["SenderHooks", RequestedValue$1_$reflection(list_type(DTO_SenderHookDto_$reflection()))], ["ActiveProcedureId", option_type(ProcedureId_$reflection())], ["ActiveProcedureTemplateId", option_type(class_type("System.Guid"))], ["CompletedSenderHookTemplateIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [class_type("System.Guid")])], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function fetchSenderHooksCmd(tool) {
    const request = new DTO_GetSenderHooksRequest(map((c) => parse(c.CategoryId), tool.Categories), tool.Id);
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_SenderHookDto_$reflection())));
        }, refreshOn)))(true);
    })), ["/api/procedure-templates/hooks/assignment-sender", toString(0, Auto_generateBoxedEncoder_437914C6(DTO_GetSenderHooksRequest_$reflection(), undefined, undefined, undefined)(request))], (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(12, [Item_1])));
}

function hasMandatoryUncompletedSenderHooks(senderHooks, completedIds) {
    if (senderHooks.tag === 0) {
        return true;
    }
    else {
        return exists((h) => {
            if (h.IsMandatory) {
                return !contains(h.ProcedureTemplateId, completedIds);
            }
            else {
                return false;
            }
        }, senderHooks.fields[0]);
    }
}

function init(tool, successCallback, onClose) {
    let businessUnitId;
    return [new State(tool, new AssignToolWithoutNotificationDto("", "", undefined, undefined, empty()), undefined, undefined, FormState_get_empty(), successCallback, onClose, new RequestedValue$1(0, []), new ToolId_1(parse(tool.Id)), new RequestedValue$1(0, []), undefined, undefined, empty_1({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), empty(), false), Cmd_batch(ofArray([(businessUnitId = tool.BusinessUnitId, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item_1) => (new Msg(5, [Item_1])), (Item_2) => (new Msg(12, [Item_2])))), fetchSenderHooksCmd(tool)]))];
}

function update(msg, state) {
    let bind$0040, body, matchValue_1, file_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.Tool, (bind$0040 = state.Dto, new AssignToolWithoutNotificationDto(bind$0040.ReceiverId, msg.fields[0], bind$0040.SignatureUrl, bind$0040.PlannedReturnDate, bind$0040.SenderImageUrls)), state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 2:
            return [new State(state.Tool, state.Dto, msg.fields[0], state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 3: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 4: {
            const matchValue = state.SelectedReceiver;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const receiver = matchValue;
                const senderImageUrls = choose((f) => {
                    if (f.tag === 1) {
                        return f.fields[0].ImageUrl;
                    }
                    else {
                        return undefined;
                    }
                }, state.SenderImageFiles);
                let dto;
                const bind$0040_1 = state.Dto;
                dto = (new AssignToolWithoutNotificationDto(receiver.value.Id, bind$0040_1.Comment, bind$0040_1.SignatureUrl, map_1(toISOString, state.SelectedReturnDate), senderImageUrls));
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_assignCmd(state.ToolId, dto, (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(12, [Item_1])))];
            }
        }
        case 5:
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 6: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, new RequestedValue$1(1, [empty()]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, new RequestedValue$1(1, [response_2.fields[0]]), state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 7: {
            const hook = msg.fields[0];
            const dto_1 = new DTO_CreateProcedureDto(state.Tool.Id);
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, hook.ProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), (body = toString(0, Auto_generateBoxedEncoder_437914C6(DTO_CreateProcedureDto_$reflection(), undefined, undefined, undefined)(dto_1)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_3) => {
                    const pr = response_3.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), [concat("/api/procedure-templates/", toString_1(new ProcedureTemplateId(hook.ProcedureTemplateId)), ..."/procedure"), body], (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(12, [Item_3]))))];
        }
        case 8:
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, new ProcedureId(msg.fields[0]), msg.fields[1], state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 9: {
            const response_4 = msg.fields[0];
            if (response_4.tag === 1) {
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0]), state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, new ProcedureId(parse(response_4.fields[0])), state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 10:
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, undefined, undefined, (matchValue_1 = state.ActiveProcedureTemplateId, (matchValue_1 == null) ? state.CompletedSenderHookTemplateIds : add(matchValue_1, state.CompletedSenderHookTemplateIds)), state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 11:
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, undefined, undefined, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), fetchSenderHooksCmd(state.Tool)];
        case 12:
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, false), Cmd_none()];
        case 13: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x_1, y) => ((x_1 + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, newFiles, true), uploadImage((Item_6) => (new Msg(14, [Item_6])), (Item_7) => (new Msg(12, [Item_7])), formData)];
                }
                default:
                    return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 14: {
            const response_5 = msg.fields[0];
            switch (response_5.tag) {
                case 0:
                    return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_2, y_1) => (comparePrimitives(x_2, y_1) | 0),
                    })) | 0;
                    return [new State(state.Tool, state.Dto, state.SelectedReturnDate, state.SelectedReceiver, state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_5.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default:
            return [new State(state.Tool, state.Dto, state.SelectedReturnDate, msg.fields[0], state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.ToolId, state.SenderHooks, state.ActiveProcedureId, state.ActiveProcedureTemplateId, state.CompletedSenderHookTemplateIds, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
    }
}

function SenderHooksSection(props) {
    let elems_4, elems_3;
    const patternInput = useTranslation();
    if (isEmpty(props.SenderHooks)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: patternInput[0]("procedure.hooks.sender_procedures"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_3 = toList(delay(() => collect((hook) => {
            let elems_2;
            const isCompleted = contains(hook.ProcedureTemplateId, props.CompletedSenderHookTemplateIds);
            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "gap-2"])], (elems_2 = toList(delay(() => {
                let children;
                return append_1(singleton_1((children = toList(delay(() => {
                    let elems, elems_1;
                    return isCompleted ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-green"])], (elems = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "text-border"])], (elems_1 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                })), reactElement("div", {
                    children: reactApi.Children.toArray(Array.from(children)),
                }))), delay(() => (isCompleted ? singleton_1(reactElement("span", {
                    className: join(" ", ["text-sm"]),
                    children: hook.ProcedureTemplateName,
                })) : singleton_1(createElement(TextButton, {
                    ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                    Label: hook.ProcedureTemplateName,
                    OnClick: () => {
                        const matchValue = hook.ProcedureId;
                        if (matchValue == null) {
                            props.Dispatch(new Msg(7, [hook]));
                        }
                        else {
                            props.Dispatch(new Msg(8, [matchValue, hook.ProcedureTemplateId]));
                        }
                    },
                    TestId: `sender-procedure-${hook.ProcedureTemplateId}`,
                    Variant: "blueButton",
                })))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }, props.SenderHooks))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
}

function DialogBody(props) {
    let elems_2;
    const t = useTranslation()[0];
    const today = date_1(utcNow());
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems;
        return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(ToolInfo, {
            DisplayReservationAlert: true,
            ToolId: new ToolId_1(parse(props.Tool.Id)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(singleton_1(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: "enabled",
            IsClearable: false,
            Key: "assign-tool-select-user",
            NoOptionsMessage: "select.employee_no_options",
            OnChange: props.SetSelectedReceiver,
            Options: map((tupledArg) => {
                const receiverType = tupledArg[0];
                const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map((receiver_1) => {
                    const matchValue = receiver_1.LocationName;
                    if (matchValue != null) {
                        const locationName = matchValue;
                        if (equals(receiverType, new ReceiverTypeName(4, []))) {
                            return {
                                label: concat(locationName, " - ", ...receiver_1.Name),
                                value: receiver_1,
                            };
                        }
                        else {
                            return {
                                label: concat(receiver_1.Name, " - ", ...locationName),
                                value: receiver_1,
                            };
                        }
                    }
                    else {
                        return {
                            label: receiver_1.Name,
                            value: receiver_1,
                        };
                    }
                }, tupledArg[1]), {
                    Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                }));
                return {
                    label: Helper_receiverTypeNameTranslation(t, receiverType),
                    options: receivers_1,
                };
            }, List_groupBy((receiver) => receiver.ReceiverType, filter((r) => (r.Id !== props.AssignedReceiverId), props.Receivers), {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            })),
            PlaceholderKey: "select.employee_placeholder",
            Value: unwrap(props.SelectedReceiver),
        }))), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: props.ComponentState,
            Label: t("general.comment"),
            OnChange: props.SetComment,
            TestId: "assign-tool-comment",
            Value: props.Comment,
        })), delay(() => append_1(singleton_1(createElement(DatePicker, {
            ComponentState: (props.ComponentState === "disabled") ? "disabled" : "enabled",
            IsClearable: true,
            Label: t("tool.dialog_planned_return_date"),
            OnChange: props.SetReturnDate,
            TestId: "assign-tool-from-user-to-user-planned-returned-date-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "plannedReturnDate")),
            Value: unwrap(props.ReturnDate),
        })), delay(() => {
            let elems_1;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("assignment_notification.sender_images"),
            }), createElement(ImageUpload, {
                ComponentState: props.ImageUploading ? "disabled" : props.ComponentState,
                SelectedFiles: props.SenderImageFiles,
                SetSelectedFile: (files) => {
                    props.Dispatch(new Msg(13, [files]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append_1(singleton_1(createElement(SenderHooksSection, {
                CompletedSenderHookTemplateIds: props.CompletedSenderHookTemplateIds,
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                SenderHooks: props.SenderHooks,
            })), delay(() => {
                const matchValue_2 = FormState__getValidation(props.FormState, t, "global");
                if (matchValue_2 == null) {
                    return empty_2();
                }
                else {
                    return singleton_1(createElement(ErrorAlert, {
                        Label: matchValue_2,
                    }));
                }
            }))));
        }))))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function OpenDialog(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Tool, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return reactElement("div", createObj(singleton((elems = toList(delay(() => {
        let matchValue;
        return append_1((matchValue = state_1.ActiveProcedureId, (matchValue == null) ? (empty_2()) : singleton_1(createElement(OpenProcedureModal, {
            IsOpen: true,
            OnCancelCallback: () => {
                dispatch(new Msg(11, []));
            },
            OnClose: () => {
                dispatch(new Msg(11, []));
            },
            OnSuccessCallback: () => {
                dispatch(new Msg(10, []));
            },
            ProcedureId: matchValue,
        }))), delay(() => {
            let Title, Label_1;
            return singleton_1(createElement(Dialog, (Title = t("tool.assign_now_to_other_user"), {
                Body: toList(delay(() => {
                    const matchValue_1 = state_1.Receivers;
                    const matchValue_2 = state_1.SenderHooks;
                    let matchResult, receivers, senderHooks;
                    if (matchValue_1.tag === 1) {
                        if (matchValue_2.tag === 1) {
                            matchResult = 0;
                            receivers = matchValue_1.fields[0];
                            senderHooks = matchValue_2.fields[0];
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton_1(createElement(DialogBody, {
                                AssignedReceiverId: props.AssignedReceiverId,
                                Comment: state_1.Dto.Comment,
                                CompletedSenderHookTemplateIds: state_1.CompletedSenderHookTemplateIds,
                                ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                                Dispatch: dispatch,
                                FormState: state_1.FormState,
                                ImageUploading: state_1.ImageUploading,
                                Receivers: receivers,
                                ReturnDate: unwrap(state_1.SelectedReturnDate),
                                SelectedReceiver: unwrap(state_1.SelectedReceiver),
                                SenderHooks: senderHooks,
                                SenderImageFiles: state_1.SenderImageFiles,
                                SetComment: (value) => {
                                    dispatch(new Msg(1, [value]));
                                },
                                SetReturnDate: (value_1) => {
                                    dispatch(new Msg(2, [value_1]));
                                },
                                SetSelectedReceiver: (value_2) => {
                                    dispatch(new Msg(0, [value_2]));
                                },
                                Tool: props.Tool,
                            }));
                        default:
                            return singleton_1(createElement(Skeleton, {
                                Variant: "normal",
                            }));
                    }
                })),
                Controls: ofArray([createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("general.cancel"),
                    OnClick: props.OnClose,
                    TestId: "close-reservation-dialog-test-id",
                    Variant: "blueButton",
                }), createElement(TextButton, (Label_1 = t("general.save"), {
                    ComponentState: (state_1.FormState.IsLoading ? true : state_1.ImageUploading) ? "disabled" : (((state_1.SelectedReceiver == null) ? true : hasMandatoryUncompletedSenderHooks(state_1.SenderHooks, state_1.CompletedSenderHookTemplateIds)) ? "disabled" : "enabled"),
                    Label: Label_1,
                    OnClick: () => {
                        dispatch(new Msg(4, []));
                    },
                    TestId: "save-assign-dialog-test-id",
                    Variant: "blueButton",
                }))]),
                IsOpen: props.IsOpen,
                OnClose: props.OnClose,
                Title: Title,
            })));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

